/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BreachGraphRequest
 */
export interface BreachGraphRequest {
  /**
   * simulation time in seconds
   */
  startTime: number;
  /**
   * Maximum number of points of history to return
   */
  historyPointsLimit?: number;
  /**
   * Subscribe for new results during simulation
   */
  subscribe: boolean;
  /**
   * Max number of items per second for subscription
   */
  subscribeRateLimit?: number;
  /**
   *
   */
  lineId: number;
}

/**
 * Check if a given object implements the BreachGraphRequest interface.
 */
export function instanceOfBreachGraphRequest(value: object): value is BreachGraphRequest {
  if (
    (!("startTime" in (value as Record<string, any>)) &&
      !("start_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["startTime"] === undefined &&
      (value as Record<string, any>)["start_time"] === undefined)
  )
    return false;
  if (!("subscribe" in value) || value["subscribe"] === undefined) return false;
  if (
    (!("lineId" in (value as Record<string, any>)) &&
      !("line_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["lineId"] === undefined &&
      (value as Record<string, any>)["line_id"] === undefined)
  )
    return false;
  return true;
}

export function BreachGraphRequestFromJSON(json: any): BreachGraphRequest {
  return BreachGraphRequestFromJSONTyped(json, false);
}

export function BreachGraphRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BreachGraphRequest {
  if (json == null) {
    return json;
  }
  return {
    startTime: json["start_time"],
    historyPointsLimit:
      json["history_points_limit"] == null ? undefined : json["history_points_limit"],
    subscribe: json["subscribe"],
    subscribeRateLimit:
      json["subscribe_rate_limit"] == null ? undefined : json["subscribe_rate_limit"],
    lineId: json["line_id"],
  };
}

export function BreachGraphRequestToJSON(json: any): BreachGraphRequest {
  return BreachGraphRequestToJSONTyped(json, false);
}

export function BreachGraphRequestToJSONTyped(
  value?: BreachGraphRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    start_time: value["startTime"],
    history_points_limit: value["historyPointsLimit"],
    subscribe: value["subscribe"],
    subscribe_rate_limit: value["subscribeRateLimit"],
    line_id: value["lineId"],
  };
}
